const initialState = () => ({
  states: [],
  countries: [],
  products: [],
  allProducts: [],
});

export default initialState;
